import { AmenityItem, TripAmenity } from '@/models/dto/Amenity'
import {
  AmenityTypeId,
  AmenityTypeKey,
  VehicleAmenityAttestedStatus,
  VehicleAmenityInactiveReasonType,
  VehicleTypeKey,
} from './enum'
import deepClone from './deepClone'
import { ConfirmReferralAmenitiesRequest } from '@/models/dto/VehicleAmenityRequirements'
import { VehicleAmenityDTO } from '@/models/dto'

export const AVAILABLE_AMENITIES: AmenityItem[] = [
  {
    key: AmenityTypeKey.Wifi,
    icon: 'wifi',
    title: 'Wifi',
    required: false,
    vehicleTypeKeys: [VehicleTypeKey.CharterBus],
  },
  {
    key: AmenityTypeKey.Luggage,
    icon: 'luggage',
    title: 'Luggage',
    required: false,
    vehicleTypeKeys: [VehicleTypeKey.CharterBus],
  },
  {
    key: AmenityTypeKey.Bathroom,
    icon: 'bathroom',
    title: 'Bathroom',
    required: false,
    vehicleTypeKeys: [VehicleTypeKey.CharterBus],
  },
  {
    key: AmenityTypeKey.SeatBelts,
    icon: 'seat_belt',
    title: 'Seat Belts',
    required: false,
    vehicleTypeKeys: [
      VehicleTypeKey.CharterBus,
      VehicleTypeKey.MiniBus,
      VehicleTypeKey.Sprinter,
    ],
  },
  {
    key: AmenityTypeKey.ADACompliant,
    icon: 'bus',
    title: 'ADA Compliant',
    required: true,
    vehicleTypeKeys: [VehicleTypeKey.CharterBus],
  },
  {
    key: AmenityTypeKey.TVScreens,
    icon: 'television',
    title: 'TV Screens',
    required: false,
    vehicleTypeKeys: [VehicleTypeKey.CharterBus],
  },
  {
    key: AmenityTypeKey.Outlets,
    icon: 'power',
    title: 'Outlets',
    required: false,
    vehicleTypeKeys: [VehicleTypeKey.CharterBus],
  },
  {
    key: AmenityTypeKey.LeatherSeats,
    icon: 'airline_seat_recline_extra',
    title: 'Leather Seats',
    required: false,
    vehicleTypeKeys: [
      VehicleTypeKey.CharterBus,
      VehicleTypeKey.MiniBus,
      VehicleTypeKey.Sprinter,
    ],
  },
  {
    key: AmenityTypeKey.CDCCompliant,
    icon: 'badge',
    title: 'CDC Compliant',
    required: false,
    vehicleTypeKeys: [VehicleTypeKey.CharterBus],
  },
  {
    key: AmenityTypeKey.DODCompliant,
    icon: 'badge',
    title: 'DOD Compliant',
    required: false,
    vehicleTypeKeys: [VehicleTypeKey.CharterBus],
  },
  {
    key: AmenityTypeKey.SPABCompliant,
    icon: 'badge',
    title: 'SPAB',
    required: true,
    vehicleTypeKeys: [
      VehicleTypeKey.CharterBus,
      VehicleTypeKey.MiniBus,
      VehicleTypeKey.Sprinter,
    ],
  },
  {
    key: AmenityTypeKey.AlcoholConsumption,
    icon: 'liquor',
    title: 'Alcohol Allowed',
    required: false,
    vehicleTypeKeys: [
      VehicleTypeKey.CharterBus,
      VehicleTypeKey.MiniBus,
      VehicleTypeKey.Sprinter,
    ],
  },
  {
    key: AmenityTypeKey.MountainTrip,
    icon: 'landscape',
    title: 'Mountain Trip',
    required: false,
    vehicleTypeKeys: [],
  },
  {
    key: AmenityTypeKey.NineteenACertification,
    icon: 'badge',
    title: '19A Certification',
    required: true,
    vehicleTypeKeys: [
      VehicleTypeKey.CharterBus,
      VehicleTypeKey.MiniBus,
      VehicleTypeKey.Sprinter,
    ],
  },
  {
    key: AmenityTypeKey.AuxBluetooth,
    icon: 'bluetooth',
    title: 'Aux/Bluetooth',
    required: false,
    vehicleTypeKeys: [VehicleTypeKey.CharterBus],
  },
  {
    key: AmenityTypeKey.PASystem,
    icon: 'mic',
    title: 'PA System',
    required: false,
    vehicleTypeKeys: [VehicleTypeKey.CharterBus],
  },
  {
    key: AmenityTypeKey.BottledWater,
    icon: 'water_drop',
    title: 'Bottled Water',
    required: false,
    vehicleTypeKeys: [
      VehicleTypeKey.CharterBus,
      VehicleTypeKey.MiniBus,
      VehicleTypeKey.Sprinter,
    ],
  },
  {
    key: AmenityTypeKey.MakeModelYear,
    icon: 'description',
    title: 'Make/Model/Year',
    required: false,
    vehicleTypeKeys: [
      VehicleTypeKey.CharterBus,
      VehicleTypeKey.MiniBus,
      VehicleTypeKey.Sprinter,
    ],
  },
  {
    key: AmenityTypeKey.VehicleColor,
    icon: 'palette',
    title: 'Vehicle Color',
    required: false,
    vehicleTypeKeys: [
      VehicleTypeKey.CharterBus,
      VehicleTypeKey.MiniBus,
      VehicleTypeKey.Sprinter,
    ],
  },
  {
    key: AmenityTypeKey.VehicleLogos,
    icon: 'grid_view',
    title: 'Vehicle Logos',
    required: false,
    vehicleTypeKeys: [
      VehicleTypeKey.CharterBus,
      VehicleTypeKey.MiniBus,
      VehicleTypeKey.Sprinter,
    ],
  },
  {
    key: AmenityTypeKey.NonStandard,
    icon: 'bus',
    title: 'Non-Standard Vehicle',
    required: false,
    vehicleTypeKeys: [
      VehicleTypeKey.CharterBus,
      VehicleTypeKey.MiniBus,
      VehicleTypeKey.Sprinter,
    ],
  },
  {
    key: AmenityTypeKey.TripCoordinators,
    icon: 'groups',
    title: 'Trip Coordinators',
    required: false,
    vehicleTypeKeys: [
      VehicleTypeKey.CharterBus,
      VehicleTypeKey.MiniBus,
      VehicleTypeKey.Sprinter,
    ],
  },
  {
    key: AmenityTypeKey.BusWraps,
    icon: 'gradient',
    title: 'Vehicle Wraps',
    required: false,
    vehicleTypeKeys: [
      VehicleTypeKey.CharterBus,
      VehicleTypeKey.MiniBus,
      VehicleTypeKey.Sprinter,
    ],
  },
  {
    key: AmenityTypeKey.VehicleStaysOnSite,
    icon: 'departure_board',
    title: 'Vehicle Stays on Site',
    required: true,
    vehicleTypeKeys: [],
  },
]

export const AMENITY_CARD_SUPPORTED_VEHICLE_TYPE_KEYS = [
  VehicleTypeKey.CharterBus,
  VehicleTypeKey.MiniBus,
  VehicleTypeKey.Sprinter,
]

export const GUARANTEED_AMENITY_TYPE_KEYS = [
  AmenityTypeKey.Wifi,
  AmenityTypeKey.Luggage,
  AmenityTypeKey.LeatherSeats,
  AmenityTypeKey.Bathroom,
  AmenityTypeKey.AlcoholConsumption,
  AmenityTypeKey.SPABCompliant,
  AmenityTypeKey.ADACompliant,
  AmenityTypeKey.SeatBelts,
  AmenityTypeKey.Outlets,
  AmenityTypeKey.TVScreens,
  AmenityTypeKey.MountainTrip,
  AmenityTypeKey.NineteenACertification,
  AmenityTypeKey.AuxBluetooth,
  AmenityTypeKey.PASystem,
  AmenityTypeKey.BottledWater,
  AmenityTypeKey.VehicleStaysOnSite,
]

export const BEST_EFFORT_AMENITY_TYPE_KEYS = [
  AmenityTypeKey.MakeModelYear,
  AmenityTypeKey.VehicleColor,
  AmenityTypeKey.VehicleLogos,
  AmenityTypeKey.NonStandard,
  AmenityTypeKey.TripCoordinators,
  AmenityTypeKey.BusWraps,
]

// Vehicle Profile Amenity Classifications
export const complianceAmenities = [
  { id: AmenityTypeId.ADACompliant, label: 'ADA Compliant' },
  { id: AmenityTypeId.SeatBelts, label: 'Seat Belts' },
  { id: AmenityTypeId.CDCCompliant, label: 'CDC Compliant' },
  { id: AmenityTypeId.DODCompliant, label: 'DOD Compliant' },
  { id: AmenityTypeId.SPABCompliant, label: 'SPAB' },
]

export const standardAmenities = [
  { id: AmenityTypeId.Luggage, label: 'Luggage' },
  { id: AmenityTypeId.Bathroom, label: 'Bathroom' },
  { id: AmenityTypeId.ACHeat, label: 'AC Heat' },
]

export const additionalAmenities = [
  { id: AmenityTypeId.Wifi, label: 'Wifi' },
  { id: AmenityTypeId.Outlets, label: 'Outlets' },
  { id: AmenityTypeId.AlcoholConsumption, label: 'Alcohol Consumption' },
  { id: AmenityTypeId.TVScreens, label: 'TV Screens' },
  { id: AmenityTypeId.LeatherSeats, label: 'Leather Seats' },
  { id: AmenityTypeId.PASystem, label: 'PA System' },
  { id: AmenityTypeId.AuxBluetooth, label: 'Aux/Bluetooth' },
]

/**
 * Returns a list of amenity items that are both supported by the given vehicle
 * type and included in the given list of trip amenities.
 *
 * @param {TripAmenity[]} amenities - The list of trip amenities.
 * @param {string} vehicleTypeKey - The key of the vehicle type.
 * @return {AmenityItem[]} A list of supported and included amenity items.
 */
export const getAvailableAmenityItemsByVehicleTypeKey = (
  amenities: TripAmenity[],
  vehicleTypeKey: string
): AmenityItem[] => {
  if (!amenities || !vehicleTypeKey) {
    return []
  }
  return deepClone(AVAILABLE_AMENITIES).filter(
    (amenity) =>
      amenity.vehicleTypeKeys.includes(vehicleTypeKey as VehicleTypeKey) &&
      amenities.some((a) => a.key === amenity.key)
  )
}

/**
 * Filters and returns the supported and included trip amenities for a given
 * vehicle type.
 *
 * @param {TripAmenity[]} amenities - The list of trip amenities.
 * @param {string} vehicleTypeKey - The key of the vehicle type.
 * @return {TripAmenity[]} The filtered list of supported and included trip amenities.
 */
export const getAvailableTripAmenitiesByVehicleTypeKey = (
  amenities: TripAmenity[],
  vehicleTypeKey: string
): TripAmenity[] => {
  if (!amenities || !vehicleTypeKey) {
    return []
  }
  const availableAmenityTypeKeys = getAvailableAmenityItemsByVehicleTypeKey(
    amenities,
    vehicleTypeKey
  ).map(({ key }) => key)
  return amenities.filter(({ key }) =>
    availableAmenityTypeKeys.includes(key as AmenityTypeKey)
  )
}

/**
 * Filters and returns the required amenities from a list of amenities.
 *
 * @param {TripAmenity[]} amenities - The list of amenities to filter.
 * @returns {AmenityItem[]} The filtered list of required amenities.
 */
export const getRequiredAmenityItems = (
  amenities: TripAmenity[],
  isMountain: boolean
): AmenityItem[] => {
  if (!amenities) {
    return []
  }
  const requiredAmenities = AVAILABLE_AMENITIES.filter(
    ({ required }) => required
  ).filter(({ key }) => amenities.some((amenity) => amenity.key === key))

  if (isMountain) {
    requiredAmenities.push(
      AVAILABLE_AMENITIES.find(
        (amenity) => amenity.key === AmenityTypeKey.MountainTrip
      )
    )
  }

  return requiredAmenities
}

export const doesListContainGuaranteedAmenity = (
  amenities: TripAmenity[]
): boolean => {
  return amenities.some(({ key }) =>
    GUARANTEED_AMENITY_TYPE_KEYS.includes(key as AmenityTypeKey)
  )
}

/**
 * Accepts an event as a parameter, and returns an array of selected amenities
 * based on whether the amenity is being added or removed.
 * If the event's value is true, we add the amenity to the list of selected amenities.
 * If the event's value is false, we remove the amenity from the list of selected amenities.
 *
 * @param update - Update object containing the amenity key and selection value
 * @param currentAmenities - Current list of selected amenities
 * @returns Updated array of selected amenities
 */
export const updateSelectedAmenities = (
  event: { key: AmenityTypeKey; value: boolean },
  currentAmenities: AmenityTypeKey[]
): AmenityTypeKey[] => {
  const { key, value } = event
  const updatedAmenities = [...currentAmenities]

  if (value && !updatedAmenities.includes(key)) {
    updatedAmenities.push(key)
  } else if (!value) {
    return updatedAmenities.filter((amenityKey) => amenityKey !== key)
  }

  return updatedAmenities
}

/**
 * Build the payload for confirming trip amenities based on which amenities have been confirmed
 * Payload should contain an array of amenity type ids and whether they have been confirmed
 *
 * @param amenitiesOnReferral - amenities on the trip that are being confirmed
 * @param tripId
 * @param referralIds
 * @param confirmedOptionalAmenities - array of AmenityTypeKeys that have been confirmed
 * @param areRequiredAmenitiesConfirmed - boolean of whether required amenities have been confirmed
 */
export const buildConfirmReferralAmenitiesRequest = (
  amenitiesOnReferral: TripAmenity[],
  tripId: number,
  referralIds: number[],
  confirmedOptionalAmenities: AmenityTypeKey[],
  areRequiredAmenitiesConfirmed: boolean
): ConfirmReferralAmenitiesRequest => {
  const referralAmenityConfirmations = []
  for (const amenity of amenitiesOnReferral) {
    if (GUARANTEED_AMENITY_TYPE_KEYS.includes(amenity.key as AmenityTypeKey)) {
      referralAmenityConfirmations.push({
        amenityTypeId: amenity.id,
        isConfirmed: areRequiredAmenitiesConfirmed,
      })
    } else {
      referralAmenityConfirmations.push({
        amenityTypeId: amenity.id,
        isConfirmed: confirmedOptionalAmenities.includes(
          amenity.key as AmenityTypeKey
        ),
      })
    }
  }
  return {
    tripId,
    referralIds,
    referralAmenityConfirmations,
  }
}

/**
 * Get the amenity supported status by checking the new attestedStatus and the legacy isSupported field.
 * @param vehicleAmenity - The VehicleAmenityDTO to check for supported status
 * @returns true if the amenity is supported, null if it's unknown or undefined, and false if it's not supported.
 */
export const amenityIsSupported = (
  vehicleAmenity: VehicleAmenityDTO
): boolean | null => {
  if (!vehicleAmenity) {
    return null
  }

  if (
    vehicleAmenity.attestedStatus === VehicleAmenityAttestedStatus.UnderReview
  ) {
    return true
  }

  const attestedStatusUnverified =
    vehicleAmenity.attestedStatus === VehicleAmenityAttestedStatus.Unverified
  const inactiveReasonTypeUnknown =
    !vehicleAmenity.isSupported &&
    (vehicleAmenity.inactiveReasonType?.key ===
      VehicleAmenityInactiveReasonType.Unknown ||
      !vehicleAmenity.inactiveReasonType)

  if (attestedStatusUnverified || inactiveReasonTypeUnknown) {
    return null
  }

  const attestedStatusSupported =
    vehicleAmenity.attestedStatus ===
    VehicleAmenityAttestedStatus.MeetsExpectation

  return attestedStatusSupported || vehicleAmenity.isSupported
}
